import React, { useEffect, useState } from "react";
import { Ptag } from "components/core/fonts";
import { useNavigate, useLocation } from "react-router";
import http from "services/httpService";
import UploadAnimatinon from "assets/lottie/upload_pending.json";
import Lottie from "react-lottie";

const intervalTime = 15 * 1000; // 15 seconds

const Pending = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const super_task_id = localStorage.getItem("super_task_id");
  const [taskStatus, setTaskStatus] = useState();
  const [cutOffDate, setCutoffDate] = useState();
  const [postIssuance, setPostIssuance] = useState();

  useEffect(() => {
    const postIssuanceData = localStorage.getItem("gmc_details");
    if (postIssuanceData) setPostIssuance(true);
    state && state?.cutoff_date && setCutoffDate(state.cutoff_date);
    const interval = setInterval(async () => {
      await getTaskStatus();
    }, intervalTime);
    (async function () {
      await getTaskStatus();
    })();
    return () => clearInterval(interval);
  }, []);

  const getTaskStatus = async () => {
    const payload = {
      params: {
        super_task_id,
      },
    };
    try {
      const { data } = await http.get("business/get_taskset_details/", payload);
      setTaskStatus(data.task_set_data);
    } catch (err) {}
  };

  useEffect(() => {
    const pageToShow = taskStatus?.status;
    switch (pageToShow) {
      case "Failure":
        navigate(
          {
            pathname: "/v1/data-collection-history/collect/error",
            state: { cutoff_date: cutOffDate },
          },
          {
            replace: true,
          }
        );
        break;
      // case "PRODUCTS_INSERT":
      //   navigate({
      //     pathname: `/${routes.FLEX_PRODUCT_UPLOAD}`,
      //     state: { flow: state && state.flow },
      //   }, {
      //     replace: true
      //   });
      //   break;
      case "Success":
        navigate("/v1/data-collection-history");
        break;
    }
  }, [taskStatus]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: UploadAnimatinon,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <section
        style={{
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div>
          <Lottie
            options={defaultOptions}
            height={140}
            width={140}
            isClickToPauseDisabled
          />
          <Ptag
            fontSize="40px"
            fontWeight="800"
            textAlign="center"
            marginTop="-18px"
          >
            Please Wait
          </Ptag>
          <Ptag fontSize="16px" textAlign="center" marginTop="12px">
            {state && state.cutoff_date
              ? "Employee data is being uploaded. This might take some time."
              : "Master employee data is being uploaded. "}
          </Ptag>
        </div>
      </section>
    </>
  );
};

export default Pending;
